export const parseBooleanSelectValue = value => value === true || value === 1 || value === "1"
